import React, { useState } from 'react';
import { Button, Grid, IconButton, makeStyles } from '@material-ui/core';
import Autocomplete from '../ui_components/autocomplete_controlled';
import { API_ROUTES } from '../../constants/api_routes';
import { AddBox } from '@material-ui/icons';
import TextInput from '../ui_components/text_input';
import { Delete } from '@material-ui/icons';
import TherapyComponent from '../therapy/therapy';
import FormShortcut from '../ui_components/form_shortcut';
import PropTypes from "prop-types";
import { useSnackbar } from 'notistack';
import { ErrorMessage } from '@hookform/error-message';

const useStyles = makeStyles((theme) => ({
	container: {
        width: 'auto',
        padding: theme.spacing(2, 5)
	},
    saveButtonGrid: {
        textAlign: 'right'
    },
    alignCenter: {
        textAlign: 'center'
    },
    iconButton: {
        padding: theme.spacing(0),
        marginTop: theme.spacing(3)
    },
    inlineFlex: {
        display: 'inline-flex'
    },
    form: {
		width: '93%',
		marginTop: theme.spacing(1)
	},
    marginTop: {
        marginTop: '40px'
    }
}));

const FormDigitalRecordTherapy = ({fields, append, remove, setValue, control, errors}) => {

    const { iconButton, inlineFlex, form, marginTop } = useStyles();
    const { enqueueSnackbar } = useSnackbar();

    // Therapy Component shortcut
    const [openTherapyComponent, setOpenTherapyComponent] = useState(false);
    const handleClickOpenTherapyComponent = (index) => {
        setOpenTherapyComponent(index);
    };
    const handleCloseTherapyComponent = () => {
        setOpenTherapyComponent(false);
    };

    const initializeTherapy = (therapy) => {
        if(therapy){
            setValue(`digitalRecordTherapy[${openTherapyComponent}].therapy`, therapy?.['@id']);
            enqueueSnackbar('Uspešno ste sačuvali terapiju', { variant: 'success' });
        }
    };

    const handleTherapyObject = (object, index) => {
        setValue(`digitalRecordTherapy[${index}].therapy`, object?.['@id']);
        setValue(`digitalRecordTherapy[${index}].wayOfUse`, fields?.[index]?.['wayOfUse']);
    }

    return (
        <div className={form}>
            {fields.map(({ id }, index) => {
                return (
                    <div key={id}>
                    <Grid container justify="center" spacing={3}>
                        <Grid item xs={5} className={inlineFlex}>
                            <Autocomplete
                                name={`digitalRecordTherapy[${index}].therapy`}
                                required
                                control={control}
                                label="Lek"
                                placeholder="Lek"
                                handleObject={(e) => handleTherapyObject(e, index)}
                                api={API_ROUTES.THERAPIES}
                                preloadValue={fields[index]?.therapy}
                            />
                            <IconButton className={iconButton} onClick={() => handleClickOpenTherapyComponent(index)}>
                                <AddBox
                                    color="primary"
                                    fontSize="large"
                                />
                            </IconButton>
                            <ErrorMessage errors={errors} name={`digitalRecordTherapy[${index}].therapy`} as="b" />
                        </Grid>
                        <Grid item xs={5}>
                            <TextInput
                                required
                                name={`digitalRecordTherapy[${index}].wayOfUse`}
                                control={control}
                                label="Način primene"
                                rules={{ required: 'Unesite način primene' }}
                            />
                            <ErrorMessage errors={errors} name={`digitalRecordTherapy[${index}].wayOfUse`} as="b" />
                        </Grid>
                        <Grid item xs={2}>
                            <IconButton className={marginTop} type="button" variant="contained" size="small" onClick={() => remove(index)}>
                                <Delete />
                            </IconButton>
                        </Grid>
                    </Grid>
                    <FormShortcut
                        component={TherapyComponent}
                        open={openTherapyComponent === 0 || openTherapyComponent ? true : false}
                        handleClose={handleCloseTherapyComponent}
                        initialize={initializeTherapy}
                    />
                </div>
                );
            })}
            <Button type = "button" variant="contained" size="small" color="primary" onClick={() => append({'therapy': null, 'wayOfUse': ''}) }>
                dodaj terapiju
            </Button>
        </div>
    );
}

FormDigitalRecordTherapy.propTypes = {
    control: PropTypes.object,
    fields: PropTypes.array,
    append: PropTypes.func,
    remove: PropTypes.func,
    setValue: PropTypes.func,
    errors: PropTypes.object
}

export default FormDigitalRecordTherapy;

